<div class="row">
  <div
    class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 product-list-col"
    *ngFor="let p of products"
  >
    <div class="field-content menuItem product-list-card">
      <h2 [style]="{ 'background-color': primaryColor}">
        <a [routerLink]="p.link" [attr.aria-label]="'View product ' + p.title + (p.code ? ' (' + p.code + ')' : '')">
          {{ p.title }} - <span>({{ p.code }})</span>
        </a>
      </h2>
      <div class="product-image-wrap">
        <a [routerLink]="p.link" class="product-image-link" [attr.aria-label]="'View product ' + p.title + (p.code ? ' (' + p.code + ')' : '')">
          <span class="sr-only">View product {{ p.title }}<ng-container *ngIf="p.code"> ({{ p.code }})</ng-container></span>
          <span class="product-image-frame">
          <img
            class="product-image"
            loading="lazy"
            decoding="async"
            [src]="p.img"
            width="220"
            height="153"
            [attr.alt]="(p.title || 'Product') + (p.code ? ' (' + p.code + ')' : '') + ' image'"
            (error)="onProductImageError($event)"
          />
          </span>
        </a>
      </div>
    </div>
  </div>
</div>
